module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.btn_loading),
      expression: "btn_loading"
    }],
    staticClass: "org_img_block",
    class: {
      "org_img_block_enable": _vm.is_enabled,
      "org_img_block_disable": !_vm.is_enabled,
      "is_colored": _vm.is_colored,
      "has-line": _vm.isLine,
    },
    style: (_vm.button_style),
    attrs: {
      "element-loading-spinner": "el-icon-loading",
      "element-loading-custom-class": "ni-btn-loading"
    },
    on: {
      "click": _vm.nClick
    }
  }, [_c('div', {
    class: {
      "mask-class": !_vm.is_enabled
    }
  }, [(_vm.icon && _vm.icon.startsWith('#')) ? _c('svg', {
    staticClass: "icon icon-item",
    style: (_vm.icon_style),
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.icon
    }
  })]) : (_vm.icon && !_vm.icon.startsWith('#')) ? _c('span', {
    staticClass: "el-icon_item",
    class: {
      'only-icon': !_vm.text
    }
  }, [_c('i', {
    class: [_vm.icon],
    style: (_vm.icon_style)
  })]) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', {
    staticClass: "tool-icon-text"
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]) : _c('span', {
    staticClass: "tool-icon-text",
    class: {
      'show-underline': _vm.underline
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.isLine) ? _c('ni-divider', {
    attrs: {
      "direction": "vertical",
      "content-position": "center"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-4e97bb40","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ni-ui/button/button.vue
// module id = Exko
// module chunks = 81